export var RecordingEvent;
(function (RecordingEvent) {
    RecordingEvent["NONE"] = "none";
    RecordingEvent["STARTED_RECORDING"] = "started_recording";
    RecordingEvent["STOPPING_RECORDING"] = "STOPPING_RECORDING";
    RecordingEvent["STOPPED_RECORDING"] = "stopped_recording";
})(RecordingEvent || (RecordingEvent = {}));
export var RecordingType;
(function (RecordingType) {
    RecordingType["RECORDING_TYPE_NONE"] = "none";
    RecordingType["RECORDING_TYPE_LOCAL"] = "local";
    RecordingType["RECORDING_TYPE_CLOUD"] = "cloud";
})(RecordingType || (RecordingType = {}));
